<div class="loader">
  <div class="loader_spin"></div>
</div>

<div #pdfViewer id="pdfViewer" class="pdf-viewer" style="text-align: center;"></div>
